import Vue from 'vue'
import {dd,store,app} from 'systems/imports'

import BaseProcessor from 'processor/BaseProcessor'
import API from 'api/SchoolCode'

/**
 * 運営サイト情報
 */
class SchoolCode extends BaseProcessor{
  static getClassName(){ return 'SchoolCode' }

  /**
   */
  static schoolCodeActivation(input){
    return new Promise(function(resolve, reject) {
      API.schoolCodeActivation(input)
        .then((res)=>{
          return resolve({status:"ok",data:{user:res.user} })
        }).catch((e)=>{
        switch(e.name){
          case "data_not_exist":
            return resolve({status:"ng",data:{},apiErrorI18nKey:"error['5_1'][4]"})
        }
      })
    });
  }
}

export default SchoolCode



// WEBPACK FOOTER //
// ./src/processor/SchoolCode.js